import { render, staticRenderFns } from "./RenewalPermanence.vue?vue&type=template&id=1668451c&scoped=true"
import script from "./RenewalPermanence.vue?vue&type=script&lang=js"
export * from "./RenewalPermanence.vue?vue&type=script&lang=js"
import style0 from "./RenewalPermanence.vue?vue&type=style&index=0&id=1668451c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1668451c",
  null
  
)

export default component.exports